import { render, staticRenderFns } from "./DetailTopSpenderCampaign.vue?vue&type=template&id=4acc94e1&scoped=true"
import script from "./DetailTopSpenderCampaign.vue?vue&type=script&lang=js"
export * from "./DetailTopSpenderCampaign.vue?vue&type=script&lang=js"
import style0 from "./DetailTopSpenderCampaign.vue?vue&type=style&index=0&id=4acc94e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4acc94e1",
  null
  
)

export default component.exports